import { render, staticRenderFns } from "./legalAccount.vue?vue&type=template&id=ba70654c&scoped=true&"
import script from "./legalAccount.vue?vue&type=script&lang=js&"
export * from "./legalAccount.vue?vue&type=script&lang=js&"
import style0 from "./legalAccount.vue?vue&type=style&index=0&id=ba70654c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba70654c",
  null
  
)

export default component.exports